import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import ÜberunsDigitaleTransformation from '../components/About/ÜberunsDigitaleTransformation';
import PageTitleArea from '../components/Common/PageTitleArea';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import ÜberunsSimplifyData from '../components/About/ÜberunsSimplifyData';
import ÜberunsEinUnternehmenMitWertenUndMoral from '../components/About/ÜberunsEinUnternehmenMitWertenUndMoral';
import ÜberunsMitgliedschaften from '../components/About/ÜberunsMitgliedschaften';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const About = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('about_page_title')}
                description={t('about_page_description')}
                canonical={`${baseUrl}/about/`}
                openGraph={{
                    url: `${baseUrl}/about/`,
                    title: t('about_page_ogTitle'),
                    description: t('about_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/logo_og.png`,
                            width: 1200,
                            height: 630,
                            alt: t('about_page_ogImageAlt'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('about_page_ogSiteName'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'keywords',
                        content: t('about_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/about/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/about/'
                    }
                ]}
            />

            <Navbar />
            <PageTitleArea
                pageTitle={t('about_page_pageTitle')}
                pageDescription={t('about_page_pageDescription')}
            />
            <ÜberunsSimplifyData />
            <ÜberunsDigitaleTransformation />
            <ÜberunsEinUnternehmenMitWertenUndMoral />
            <ÜberunsMitgliedschaften />
            <SubscribeStyleOne />
            <Footer />
        </>
    );

}

export default About;